import { render, staticRenderFns } from "./unitTransfer.vue?vue&type=template&id=2d2cbc52&scoped=true&"
import script from "./unitTransfer.vue?vue&type=script&lang=js&"
export * from "./unitTransfer.vue?vue&type=script&lang=js&"
import style0 from "./unitTransfer.vue?vue&type=style&index=0&id=2d2cbc52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2cbc52",
  null
  
)

export default component.exports